
export default function TableLoader() {
  return (
    <div className="text-center my-3">
      <div className="table-loading"></div>
    </div>
  );
}
